export default function registerhideOnScrollController(Alpine) {
  Alpine.data("hideOnScrollController", () => ({
    showHeader: true,

    lastScrollY: 0,

    ticking: false,

    init() {
      window.addEventListener("scroll", () => {
        this.handleScroll();
      });
    },

    handleScroll() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.updateHeader();
        });

        this.ticking = true;
      }
    },

    updateHeader() {
      const currentScrollY = window.scrollY;

      const scrollingDown = currentScrollY > this.lastScrollY;

      const scrollingUp = currentScrollY < this.lastScrollY;

      if (currentScrollY < 10) {
        this.showHeader = true;
      } else if (scrollingUp) {
        this.showHeader = true;
      } else if (scrollingDown && currentScrollY > 50) {
        this.showHeader = false;
      }

      this.lastScrollY = currentScrollY <= 0 ? 0 : currentScrollY;

      this.ticking = false;
    },
  }));
}
